import { Copy05 } from '@untitled-ui/icons-react';
import React, { useCallback, useState } from 'react';

import { Tooltip } from '@myhealth-raccoon/components';

type Props<T extends HTMLElement> = {
    contentRef: React.RefObject<T>;
};

export function CopyTextButton<T extends HTMLElement>({ contentRef }: Props<T>) {
    const [didCopy, setDidCopy] = useState(false);

    const copyToClipboard = useCallback(() => {
        const content = contentRef.current?.textContent;
        if (content) {
            navigator.clipboard.writeText(content);
            setDidCopy(true);
            setTimeout(() => {
                setDidCopy(false);
            }, 1500);
        }
    }, [contentRef]);

    return (
        <Tooltip tooltipContent={didCopy ? 'Copied!' : 'Copy to clipboard'}>
            <button className="block" onClick={copyToClipboard}>
                <Copy05 className="h-6 w-6 text-gray-400" />
            </button>
        </Tooltip>
    );
}
